import React, { useState } from "react";
import DoneIcon from "@mui/icons-material/Done";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";

// import JS files
import MuiButton from "../../shares/MuiButton";
import BasketOrderCard from "./BasketOrderCard";
import { useCustomerBasket } from "../../../context/CustomerBasketContext";
import { useUserData } from "../../../context/UserDataContext";
import useFetch from "../../../context/useFetch";
import SizeTextGrid from "../../shares/SizeTextGrid";
import { useSetting } from "../../../context/SettingContext";
import { useLocation, useNavigate } from "react-router-dom";
import MuiModal from "../../shares/MuiModal";
// import {showNumSix} from "../../../constants/constants";

// import Others files
const BasketBoxInside = (props) => {
  const navigate = useNavigate();
  let windowWidth = window.screen.width;
  const { showNumSix } = useSetting();
  const { userSelectedRing, clearBasket, selectedUserContext, removeRing } =
    useCustomerBasket();
  const { userData } = useUserData();
  const location = useLocation();
  const [postOrderItem, setPostOrderItem] = useState([]);

  const createOrderItems = useFetch({
    method: "post",
    url: "OrderItem_Service",
    data: postOrderItem,
    argFunc: (res) => {
      clearBasket();
      if (props.isAdmin) {
        props.setSelectedUser(undefined);
        props.setSelectedCustomer(undefined);
      }

      if (location.state !== null) {
        navigate("/quick-access-edit-order");
      }

      // toast.success("سفارش موردنظر با موفقیت ثبت شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const createOrder = useFetch({
    method: "post",
    url: "Order_Service",
    data: props.AdminCreateOrderForUser
      ? {
          // creator:
          //   selectedUserContext !== undefined
          //     ? selectedUserContext.username
          //     : props.selectedCustomer,
          creator:
            props.selectedCustomer == undefined
              ? selectedUserContext?.username
              : props.selectedCustomer,
          from_admin: true,
         
        }
      : { creator: userData.username ,  is_active: userData.job == "Employee" ? false: true,
      is_pre_order: userData.job == "Employee" ? true: false, },
    argFunc: (res) => {
      let order_item = [];
      userSelectedRing.map((item, index) => {
        order_item.push({
          bangle: item.ring.id,
          order: res.id,
          size_one_num: item.nums[0] !== "" ? parseInt(item.nums[0]) : 0,
          size_two_num: item.nums[1] !== "" ? parseInt(item.nums[1]) : 0,
          size_three_num: item.nums[2] !== "" ? parseInt(item.nums[2]) : 0,
          size_four_num: item.nums[3] !== "" ? parseInt(item.nums[3]) : 0,
          size_five_num: item.nums[4] !== "" ? parseInt(item.nums[4]) : 0,

          size_six_num: showNumSix
            ? item.nums[5] !== "" && item.nums[5] !== undefined
              ? parseInt(item.nums[5])
              : 0
            : 0,
          receive_at: moment(item.date).locale("en").format("YYYY-MM-DD"),
          // total_order_weight:,
        });
      });

      setPostOrderItem(order_item);
      createOrderItems.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [patchCheckData, setPatchCheckData] = useState();

  const [getCheckData, setGetCheckData] = useState({ data: [] });

  const checkOrderItems = useFetch({
    method: "post",
    url: "Order_Service/check_order_create_items",
    data: patchCheckData,
    argFunc: (res) => {
      if (res.data.length > 0) {
        setGetCheckData(res);
        setOpenModal(true);
      } else {
        createOrder.reFetch();
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const check_order_item = () => {
    let check_item = [];
    userSelectedRing.map((item, index) => {
      check_item.push(item.ring.id);
    });

    setPatchCheckData({
      user: props.AdminCreateOrderForUser
        ? selectedUserContext !== undefined
          ? selectedUserContext.username
          : props.selectedCustomer
        : userData.username,
      ids: check_item,
    });
    checkOrderItems.reFetch();
  };

  const create_order_item = () => {
    let order_item = [];
    userSelectedRing.map((item, index) => {
      order_item.push({
        bangle: item.ring.id,
        order: location.state.orderId,
        size_one_num: item.nums[0] !== "" ? parseInt(item.nums[0]) : 0,
        size_two_num: item.nums[1] !== "" ? parseInt(item.nums[1]) : 0,
        size_three_num: item.nums[2] !== "" ? parseInt(item.nums[2]) : 0,
        size_four_num: item.nums[3] !== "" ? parseInt(item.nums[3]) : 0,
        size_five_num: item.nums[4] !== "" ? parseInt(item.nums[4]) : 0,

        size_six_num: showNumSix
          ? item.nums[5] !== "" && item.nums[5] !== undefined
            ? parseInt(item.nums[5])
            : 0
          : 0,
        receive_at: moment(item.date).locale("en").format("YYYY-MM-DD"),
        // total_order_weight:,
      });
    });

    setPostOrderItem(order_item);
    createOrderItems.reFetch();
  };

  const [openModal, setOpenModal] = useState(false);

  const create_order = () => {
    // createOrder.reFetch();
    check_order_item();
  };

  const create_checked_order = () => {
    createOrder.reFetch();
    setOpenModal(false);
  };

  const get_total_weight = () => {
    let total = 0;
    userSelectedRing.map((ri, ind) => {
      ri.nums.map((number, index) => {
        if (index == 0) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_one_weight);
          }
        }
        if (index == 1) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_two_weight);
          }
        }
        if (index == 2) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_three_weight);
          }
        }
        if (index == 3) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_four_weight);
          }
        }
        if (index == 4) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_five_weight);
          }
        }
        if (index == 5) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_six_weight);
          }
        }
      });
    });

    return total.toFixed(3);
  };

  const removeDuplicateRing = (ring_id) => {
    let bf = [...userSelectedRing];
    let ind = -1;
    for (let index = 0; index < bf.length; index++) {
      const element = bf[index];
      if (element.ring.id == ring_id) {
        ind = index;
      }
    }
    if (ind !== -1) {
      removeRing(ind);
      let check_item = [];
      userSelectedRing.map((item, index) => {
        check_item.push(item.ring.id);
      });

      setPatchCheckData({
        user: props.AdminCreateOrderForUser
          ? selectedUserContext !== undefined
            ? selectedUserContext.username
            : props.selectedCustomer
          : userData.username,
        ids: check_item.filter((it) => it !== ring_id),
      });

      checkOrderItems.reFetch();
    }
  };
  return (
    <>
      <div className="md:border md:rounded-md md:mb-4">
        <div className="hidden md:block text-center bg-emerald-600 rounded-t-md px-2 py-1">
          <span className="font-bold text-white text-lg">سبد خرید شما</span>
        </div>
        <div className="pb-6 grid grid-cols-12 gap-x-2 items-center md:p-2">
          <div className="col-span-8">
            <span className="text-xs md:text-base">
              برای نهایی کردن سفارش خود روی دکمه ثبت کلیک کنید.
            </span>
          </div>
          <div className="col-span-4 text-left">
            <MuiButton
              onClick={
                location.state !== null ? create_order_item : create_order
              }
              disabled={(userSelectedRing.length === 0) | createOrder.loading}
              variant="contained"
              icon={<DoneIcon />}
              color="primary"
              text="ثبت"
            />
          </div>
        </div>

        {openModal && (
          <MuiModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            width="w-2/5"
            // isOverflow={true}
            // isNotBackdropClick={isNotBackdropClick}
          >
            <div className="overflow-y-auto h-[30rem]">
              {/* <div> */}
              <div className="close-modal-icon">
                <CloseIcon
                  onClick={() => setOpenModal(false)}
                  fontSize="large"
                  color="secondary"
                />
              </div>
              <div className="col-span-4 mb-4 text-left">
                <MuiButton
                  onClick={create_checked_order}
                  disabled={createOrder.loading}
                  variant="contained"
                  icon={<DoneIcon />}
                  color="primary"
                  text="ثبت"
                />
              </div>
              {getCheckData.data.map((item, index) => {
                return (
                  <>
                    <div className="flex flex-row justify-between mb-4 border rounded-lg p-2 ">
                      <span className="show-label">
                        سند:{" "}
                        <span className="show-value">
                          {" "}
                          {item.order}-
                          {item.state == "onprogress"
                            ? "درحال اجرا"
                            : "ثبت شده"}
                        </span>
                      </span>
                      <div>
                        <span className="text-myblue-100">{item.code}</span>/
                        <span className="text-myblue-100">{item.bangle}</span>/
                        <span className="text-myblue-100">{item.brand}</span>/
                        <span className="bg-slate-100 rounded-lg p-1">
                          {item.gender == "girl" ? "بچه گانه" : "زنانه"}
                        </span>
                        /
                        {item.color == "yellow" ? (
                          <span className="bg-yellow-400 rounded-lg p-1">
                            زرد
                          </span>
                        ) : (
                          <span className="bg-slate-50 border border-slate-200 rounded-lg p-1">
                            سفید
                          </span>
                        )}{" "}
                      </div>
                      <div className="table-icon">
                        <DeleteIcon
                          onClick={() => removeDuplicateRing(item.bangle_id)}
                        />
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </MuiModal>
        )}

        {userSelectedRing.length > 0 ? (
          <>
            <SizeTextGrid
              haveExtraCol
              have5Col
              haveTotalWeight
              get_total_weight={get_total_weight}
            />

            <div className="md:max-h-96 md:overflow-scroll md:px-2 md:mb-2">
              {userSelectedRing.map((item, index) => {
                return [
                  <BasketOrderCard
                    fromCreateOrder={true}
                    item={item}
                    ringIndex={index}
                  />,
                ];
              })}
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col items-center justify-center text-slate-500">
              <ShoppingBasketIcon sx={{ fontSize: "4rem" }} />
              <span className="mt-4">سبد خرید شما خالی است!</span>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BasketBoxInside;
